import {type ClientMessageSubType, type ServerRecipient} from '@colonist/types'

export enum ClientSocketMessageType {
    RouteToServerType = 2,
    RouteToServerDirect = 3,
    SocketRouter = 4,
}

const textDecoder = new TextDecoder()
const textEncoder = new TextEncoder()

const TYPE_LENGTH = 1
const TYPE_INDEX = 0
const SUBTYPE_LENGTH = 1
const SUBTYPE_INDEX = TYPE_INDEX + TYPE_LENGTH
const RECIPIENT_LENGTH_LENGTH = 1
const RECIPIENT_LENGTH_INDEX = SUBTYPE_INDEX + SUBTYPE_LENGTH
const RECIPIENT_INDEX = RECIPIENT_LENGTH_INDEX + RECIPIENT_LENGTH_LENGTH

// binary format: "type byte|recipient length byte|encoded recipient|data"

export function createBinaryClientSocketMessage(type: ClientSocketMessageType, subType: ClientMessageSubType, recipient: ServerRecipient, data: Uint8Array): Uint8Array {
    const encodedRecipient = textEncoder.encode(recipient)

    const binary = new Uint8Array(TYPE_LENGTH + SUBTYPE_LENGTH + RECIPIENT_LENGTH_LENGTH + encodedRecipient.byteLength + data.byteLength)
    const binaryView = new DataView(binary.buffer)
    binaryView.setUint8(TYPE_INDEX, type)
    binaryView.setUint8(SUBTYPE_INDEX, subType)
    binaryView.setUint8(RECIPIENT_LENGTH_INDEX, encodedRecipient.byteLength)
    binary.set(encodedRecipient, RECIPIENT_INDEX)
    binary.set(data, RECIPIENT_INDEX + encodedRecipient.byteLength)

    return binary
}

export interface ClientSocketMessage {
    type: ClientSocketMessageType
    subType: ClientMessageSubType
    recipient: ServerRecipient
    data: Uint8Array // TODO it should be possible to use a DataView here to avoid copying the data
}

export function parseBinaryClientSocketMessage(binaryMessage: Uint8Array): ClientSocketMessage {
    const type = binaryMessage[TYPE_INDEX]
    const subType = binaryMessage[SUBTYPE_INDEX]
    const recipientLength = binaryMessage[RECIPIENT_LENGTH_INDEX]
    const recipient = textDecoder.decode(binaryMessage.slice(RECIPIENT_INDEX, RECIPIENT_INDEX + recipientLength))
    const data = binaryMessage.slice(RECIPIENT_INDEX + recipientLength)

    return {
        type: type,
        subType: subType,
        recipient: recipient,
        data: data,
    }
}
